import { AutomaticReadingResultData } from '../models/automatic-reading-result-data';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Injectable } from '@angular/core';
import { LiabilityService } from '../services/liability.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class AutomaticReadingResultDataResolver implements Resolve<AutomaticReadingResultData> {
  constructor(private liabilityService: LiabilityService) {
  }

  resolve(route: ActivatedRouteSnapshot): Observable<AutomaticReadingResultData> {
    const automaticReadingId = route.params.id;
    return this.liabilityService
      .getAutomaticReadingResult(automaticReadingId);
  }
}
